// D:\johnstoncompanies\johnston\src\FrontEnd\modules\content-library\src\Widgets\.tsx
import { filtersAccordionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFiltersAccordion";
import { css } from "styled-components";

filtersAccordionStyles.accordion = {
    css: css`
        padding-top: 20px;
        > div[class^="Wrapper"] {
            > dd {
                > div[class^="CheckboxGroupStyle"] {
                    > div[class^="CheckboxStyle"] {
                        > label {
                            word-break: initial;
                        }
                    }
                }
            }
        }
    `,
};
